// src/auth/AuthContext.jsx
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { login as apiLogin } from "../api/auth";
import { clearAuth, setToken } from "../api/client";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [userEmail, setUserEmail] = useState(localStorage.getItem("userEmail") || "");
    const [ready, setReady] = useState(true); // 간단 버전

    const isAuthed = !!localStorage.getItem("accessToken");

    useEffect(() => {
        const onLogout = () => {
            clearAuth();
            setUserEmail("");
        };
        window.addEventListener("auth:logout", onLogout);
        return () => window.removeEventListener("auth:logout", onLogout);
    }, []);

    async function login(email, password) {
        // 백엔드 응답 형식이 다를 수 있어서 유연하게 처리
        const res = await apiLogin(email, password);

        const access =
            res?.accessToken || res?.access_token || res?.token || res?.data?.accessToken;
        const refresh =
            res?.refreshToken || res?.refresh_token || res?.data?.refreshToken;

        if (!access) throw new Error("login response missing accessToken");

        setToken(access);
        if (refresh) localStorage.setItem("refreshToken", refresh);

        localStorage.setItem("userEmail", email);
        setUserEmail(email);

        return res;
    }

    function logout() {
        clearAuth();
        setUserEmail("");
    }

    const value = useMemo(
        () => ({ ready, isAuthed, userEmail, login, logout }),
        [ready, isAuthed, userEmail]
    );

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
    return useContext(AuthContext);
}
